interface TimelineCursorProps {
    currentTime: number;
    duration: number;
  }
  
  export function TimelineCursor({ currentTime, duration }: TimelineCursorProps) {
    const position = (currentTime / duration) * 100;
  
    return (
      <div 
        className="tw-absolute tw-top-0 tw-bottom-0 tw-w-0.5 tw-bg-red-500"
        style={{ left: `${position}%` }}
      >
        <div className="tw-absolute -tw-top-1 -tw-translate-x-1/2 tw-w-3 tw-h-3 tw-bg-red-500 tw-rounded-full" />
      </div>
    );
  }